import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default () => {

    gsap.registerPlugin(ScrollTrigger);

    const setVideoBox = document.querySelectorAll('[data-find-video]')
    // const setVideoBl = document.querySelectorAll('.bl-video video')
    setVideoBox.forEach(blVideo => {
        const setVideoBl = blVideo.querySelectorAll('[data-autoplay]')
        setVideoBl.forEach(bar => {
            // console.log(setVideoBl.parentNode);
            ScrollTrigger.create({
                trigger: blVideo,
                // markers: true,
                start: "top bottom",
                end: "bottom top",
                // toggleClass: "_active",
                onEnter: () => {
                    element.play();
                },
                onEnterBack: () => {
                    element.play();
                },
                onLeave: () => {
                    element.currentTime = 0;
                    element.load();
                },
                onLeaveBack: () => {
                    element.currentTime = 0;
                    element.load();
                },
            });
        });
    });

    const setVideoBox2 = document.querySelectorAll('video.my-bg:not(.js-video-sound)')
    // const setVideoBl = document.querySelectorAll('.bl-video video')
    setVideoBox2.forEach(blVideo => {
        const setVideoBl = blVideo.parentNode
        ScrollTrigger.create({
            trigger: setVideoBl,
            // markers: true,
            start: "top bottom",
            end: "bottom top",
            // toggleClass: "_active",
            onEnter: () => {
                blVideo.play();
            },
            onEnterBack: () => {
                blVideo.play();
            },
            onLeave: () => {
              blVideo.currentTime = 0;
              blVideo.load();
            },
            onLeaveBack: () => {
              blVideo.currentTime = 0;
              blVideo.load();
            },
        });
    });

    const setVideoBox3 = document.querySelectorAll('.bl-video video')
    // const setVideoBl = document.querySelectorAll('.bl-video video')
    setVideoBox3.forEach(blVideo => {
        const setVideoBl = blVideo.parentNode
        ScrollTrigger.create({
            trigger: setVideoBl,
            // markers: true,
            start: "top bottom",
            end: "bottom top",
            // toggleClass: "_active",
            onEnter: () => {
                blVideo.play();
            },
            onEnterBack: () => {
                blVideo.play();
            },
            onLeave: () => {
                
              blVideo.currentTime = 0;
              blVideo.load();
            },
            onLeaveBack: () => {
                
              blVideo.currentTime = 0;
              blVideo.load();
            },
        });
    });


          
    let videos = document.querySelectorAll('.video');
    if (videos.length) {
        videos.forEach(function(video) {
            // const bar  = video.querySelector('.video__volume-bar');
            const progress  = video.querySelector('.video__volume-state');
            const media  = video.querySelector('.video__el');
            const icon  = video.querySelector('.video__icon');

            ScrollTrigger.create({
              trigger: media,
              onLeave: () => media.pause(),
              // onLeaveBack: () => media.pause()
            });
            media.addEventListener('click', (e) => {
              if (media.paused) {
                media.play();
              } else {
                // media.pause();
              }
            });

            if (icon) {
              media.addEventListener('play', (e) => {
                icon.classList.add('home-slider__icon--hidden');
                video.classList.remove('remove-control');
              });
              media.addEventListener('pause', (e) => {
                icon.classList.remove('home-slider__icon--hidden');
                video.classList.add('remove-control')
              });
            }


            // sound control
            // bar.addEventListener('mousedown', initResize, false);
            // bar.addEventListener('touchstart', initResize, false);

            // function initResize(e) {
            //     Resize(e);

            //     applyEvents('add', 'mousemove, touchmove', Resize);
            //     applyEvents('add', 'mouseup, touchend', stopResize);
            // }

            function Resize(e) {
                // let progressValue;

                // if (e.type.includes('touch')) {
                //     progressValue = (e.targetTouches[0].clientX - bar.offsetLeft)/bar.clientWidth;
                // } else {
                //     progressValue = (e.clientX - bar.getBoundingClientRect().x)/bar.clientWidth;
                // }

                // let progressNormalized = Math.min(Math.max(progressValue*100, 0), 100)/100;

                // progress.style.transform = `scaleX(${progressNormalized})`;

                // if (!isNaN(progressNormalized)) {
                //     media.volume = progressNormalized;
                // }
            }

            function stopResize(e) {
                // applyEvents('remove', 'mousemove, touchmove', Resize);
                // applyEvents('remove', 'mouseup, touchend', stopResize);
            }

            function applyEvents(type, events, fn) {
                let eventsList = events.split(',');

                eventsList.forEach(function(event) {
                  event = event.trim();
                  if (type === 'add') {
                    window.addEventListener(event, fn, false);
                  } else {
                    window.removeEventListener(event, fn, false);
                  }
                });
            }
        });
    }
};
